import { useState } from 'react';

import FormTitle from 'components/PageLayout/FormTitle';
import CheckboxWrapper from 'components/curo-components/common/CheckboxWrapper/CheckboxWrapper';
import Button from 'components/digifi-wrappers/Button';
import { CuroApplicationVariables } from 'enums/curo/Variables';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import { TableValue } from 'product_modules/api/Types';
import { UserCircleIcon, DifferentPath } from 'static/images';

/* eslint-disable no-restricted-imports */
import { BankAccountType } from '../../constants';

import styles from './BankAccountExistingOrOtherStep.module.scss';

const PAGE_TITLE = 'Bank Account Information';

interface IBankAccountInformationMethodStepProps {
  onStepComplete: (selectedAccount: BankAccountType) => void;
}

const BankAccountExistingOrOtherStep = ({
  onStepComplete,
}: IBankAccountInformationMethodStepProps) => {
  const application = useAppSelector(getApplicationSelector);
  const [selectedAccount, setSelectedAccount] = useState<BankAccountType | null>(null);

  const origGpsBankAccountInformation = (
    application?.variables[CuroApplicationVariables.OrigGpsBankAccountInformation] as TableValue
  )?.[0];
  const bankAccountNumber = origGpsBankAccountInformation?.[
    CuroApplicationVariables.BankAccountNumber
  ] as string;
  const bankAccountLast4Digits = bankAccountNumber?.substring(bankAccountNumber?.length - 4);

  return (
    <>
      <FormTitle
        title={PAGE_TITLE}
        subTitle={
          <div className={styles.pageDescription}>
            In the past, we sent your funds to bank account ending {bankAccountLast4Digits}. We can
            send the funds to that account or another account that you choose. Please select an
            option below.
          </div>
        }
      />
      <div className={styles.checkboxWrapper}>
        <CheckboxWrapper
          checked={selectedAccount === BankAccountType.Existing}
          value={BankAccountType.Existing}
          onChange={(value) => setSelectedAccount(value as BankAccountType)}
          title={`Send funds to account ••••••${bankAccountLast4Digits}`}
        >
          <div className={styles.checkboxContent}>
            <UserCircleIcon />
            <span>Usually deposited next day</span>
          </div>
        </CheckboxWrapper>
        <CheckboxWrapper
          checked={selectedAccount === BankAccountType.Other}
          value={BankAccountType.Other}
          onChange={(value) => setSelectedAccount(value as BankAccountType)}
          title="Choose a different account"
        >
          <div className={styles.checkboxContent}>
            <DifferentPath />
            <span>Additional verification required</span>
          </div>
        </CheckboxWrapper>
      </div>

      <Button
        type="submit"
        kind="primary"
        size="form"
        onClick={() => {
          if (selectedAccount) {
            onStepComplete(selectedAccount);
          }
        }}
        disabled={!selectedAccount}
      >
        Continue
      </Button>
    </>
  );
};

export default BankAccountExistingOrOtherStep;
